import React, { useEffect, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  Button,
  Col,
  Icon,
  Row,
  RSelect
} from "../../../components/Component";

import {
  Modal,
  ModalBody,
} from 'reactstrap';

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, FormProvider, useForm, useWatch } from "react-hook-form";
import { NumericFormat, numericFormatter } from "react-number-format";
import { toast } from "react-toastify";
import { DELETE, GET, POST, PUT } from "../../../helper/api";
import { CURRENCY_CODE_OPTIONS, BILL_TYPE, TRUCK_TYPE } from "../../../utils/Utils";
import { formatBankAccountWithBalanceOptions } from "../../../helper/bank-account";



const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).filter(e => e !== 'SERVICE').map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));


const MONEY_FLOW_DEFAULT = {
  id: null,
  customerId: "",
  amount: "",
  bankAccountId: null,
  content: "",
  note: "",
  date: moment().format('YYYY-MM-DD'),
  currency: "VND",
  amountUSD: "",
  exchangeRate: "",
  truckId: null,
  userId: null,
};

const PNAddCustomerMoneyFlow = ({
  onClose,
  type: initType,
  id: initId,
  duplicateId,
  transactionId,
  duplicateTransactionId,
  defaultValue = {},
}) => {
  const [id, setId] = useState(duplicateId || initId);
  const [type, setType] = useState(initType)
  const methodForm = useForm({
    defaultValues: { ...MONEY_FLOW_DEFAULT, ...defaultValue },
  });
  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    setValue,
  } = methodForm;

  const currency = useWatch({
    control,
    name: "currency",
  });

  const exchangeRate = useWatch({
    control,
    name: "exchangeRate",
  });

  const amountUSD = useWatch({
    control,
    name: "amountUSD",
  });

  const debtUserId = useWatch({
    control,
    name: "debtUserId",
  });

  useEffect(() => {
    if (currency === 'VND') {
      setValue('amountUSD', '');
      setValue('exchangeRate', '');
    }

    if (currency === 'USD') {
      setValue('amount', (amountUSD && exchangeRate) ? Math.round(amountUSD * exchangeRate) : '')
    }
  }, [currency, amountUSD, exchangeRate])

  const [bankAccountOptions, setBankAccountOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [pnUserOptions, setUserOptions] = useState([]);

  const isEdit = !!id && !duplicateId && !duplicateTransactionId;

  useEffect(() => {

    GET("truck", { type: TRUCK_TYPE.TRUCK }, true)
      .then(({ data }) => {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      })

    GET("user", {
    }, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/pn-bank-account/find-all-with-balance", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setBankAccountOptions(formatBankAccountWithBalanceOptions(data));
      }
    });

    GET(`/pn-new-customer-money-flow/find-all-with-balance`, {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setCustomers(data.map((cus) => ({
          label: `${cus.name} (${numericFormatter(`${cus.lastDebt || 0}`, {
            thousandsGroupStyle: "thousand",
            thousandSeparator: ",",
            suffix: " đ",
            decimalScale: 2
          })})`,
          value: cus.id,
          data: cus,
        })))
      }
    });


    if (id) {
      GET(`/pn-new-customer-money-flow/${id}`, {}, true).then((resp) => {
        reset(resp.data);
      });
    }

    if (transactionId || duplicateTransactionId) {
      GET(`/pn-new-customer-money-flow/get-by-transaction-id/${transactionId || duplicateTransactionId}`, {}, true).then((resp) => {
        reset(resp.data);
        setType(resp.data.type);
        setId(resp.data.id)
      });
    }
  }, []);


  const onHandleSubmit = () => {
    const {
      amount,
      bankAccountId,
      content,
      customerId,
      note,
      date,
      exchangeRate,
      amountUSD,
      currency,
      truckId,
      debtUserId,
      debtUserType,
      pnHookTransactionHistoryId,
    } = getValues();

    const formData = {
      date: moment(date).format("YYYY-MM-DD"),
      amount,
      bankAccountId,
      content,
      customerId,
      note,
      type,
      amountUSD,
      exchangeRate,
      currency,

      truckId,
      debtUserId,
      debtUserType,
      pnHookTransactionHistoryId: pnHookTransactionHistoryId ? Number(pnHookTransactionHistoryId) : null,
    };

    const request = isEdit
      ? PUT(`/pn-new-customer-money-flow/${id}`, formData, {}, true)
      : POST("/pn-new-customer-money-flow", { ...formData }, {}, true);

    request
      .then(() => {
        if (isEdit) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => { });
  };

  const [view, setView] = useState({
    isDelete: false,
  });


  const [deleteId, setDeleteId] = useState();

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };


  const resetData = () => {
    setDeleteId(null)
    onFormCancel();
  };

  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, config: false });
  };


  const deleteCustomerMoneyFlow = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/pn-customer-money-flow/${id}`, {}, true)
      .then((res) => {
        toast.success(`Xóa thành công`);
        resetData();
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <div className="card card-bordered card-preview">
        <div className="card-inner">
          <h3>
            {(!isEdit ? "Thêm" : "Sửa") + " lịch sử " + (type === 'IN' ? "thu KH" : "chi NCC")}
          </h3>
          <FormProvider {...methodForm}>
            <form onSubmit={handleSubmit(onHandleSubmit)}>
              <input
                type="hidden"
                name="pnHookTransactionHistoryId"
                ref={register()}
              />
              <div className="mt-4">
                <Row className="g-2">

                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Ngày <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <input
                          className="form-control"
                          type="date"
                          name="date"
                          max={moment().format("YYYY-MM-DD")}
                          ref={register({
                            required: "Vui lòng nhập thông tin",
                          })}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="date"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Quỹ tài khoản<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="bankAccountId"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, name, value, ref }) => (
                            <RSelect
                              isClearable
                              name={name}
                              inputRef={ref}
                              options={bankAccountOptions}
                              value={
                                bankAccountOptions.find(
                                  (c) => c.value == value
                                ) || ""
                              }
                              onChange={(val) => onChange(val?.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="bankAccountId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        {type === 'OUT' ? 'Nhà cung cấp' : 'Khách hàng'}<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="customerId"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, name, value, ref }) => (
                            <RSelect
                              name={name}
                              inputRef={ref}
                              options={customers}
                              value={
                                customers.find(
                                  (c) => c.value == value
                                ) || ""
                              }
                              onChange={(val) => onChange(val.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="customerId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Nhân viên
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="debtUserId"
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isClearable
                              inputRef={ref}
                              name={name}
                              options={pnUserOptions}
                              value={pnUserOptions.find((c) => c.value === value)}
                              onChange={(val) => {
                                onChange(val?.value || null)
                                if (!val?.value) {
                                  setValue('debtUserType', null)
                                  setValue('truckId', null)
                                }
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="debtUserId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Xe {debtUserId ? <span className="text-danger">*</span> : ''}
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="truckId"
                          rules={debtUserId ? { required: "Vui lòng nhập thông tin" } : {}}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isClearable
                              isDisabled={!debtUserId}
                              inputRef={ref}
                              name={name}
                              options={truckOptions}
                              value={truckOptions.find((c) => c.value === value)}
                              onChange={(val) => onChange(val.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="truckId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Loại công nợ NV {debtUserId ? <span className="text-danger">*</span> : ''}
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="debtUserType"
                          rules={debtUserId ? { required: "Vui lòng nhập thông tin" } : {}}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              isClearable
                              isDisabled={!debtUserId}
                              inputRef={ref}
                              options={BILL_TYPE_OPTIONS}
                              value={BILL_TYPE_OPTIONS.find((c) => c.value === value)}
                              onChange={(val) => onChange(val?.value || null)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="debtUserType"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Tiền tệ
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="currency"
                          render={({ onChange, value, name, ref }) => (
                            <RSelect ref={ref} name={name} options={CURRENCY_CODE_OPTIONS} value={CURRENCY_CODE_OPTIONS.find((c) => c.value === value)} onChange={(val) => onChange(val.value)} />
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  {currency === "USD" ? (
                    <>
                      <Col md="6">
                        <div className="form-group">
                          <label className="form-label" >
                            {type === 'IN' ? 'Tiền thu ' : 'Tiền chi'}($)<span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="amountUSD"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, ref }) => (
                                <NumericFormat
                                  className="form-control"
                                  getInputRef={ref}
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={4}
                                  onValueChange={(val) => onChange(val.floatValue)}
                                />
                              )}
                            />
                            <ErrorMessage errors={errors} name="amountUSD" render={({ message }) => <span className="invalid">{message}</span>} />
                          </div>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <label className="form-label" >
                            Tỉ giá<span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <Controller
                              control={control}
                              name="exchangeRate"
                              rules={{ required: "Vui lòng nhập thông tin" }}
                              render={({ onChange, value, ref }) => (
                                <NumericFormat
                                  className="form-control"
                                  getInputRef={ref}
                                  type="text"
                                  value={value}
                                  thousandsGroupStyle="thousand"
                                  thousandSeparator=","
                                  decimalScale={2}
                                  onValueChange={(val) => onChange(val.floatValue)}
                                />
                              )}
                            />
                            <ErrorMessage errors={errors} name="exchangeRate" render={({ message }) => <span className="invalid">{message}</span>} />
                          </div>
                        </div>
                      </Col>
                    </>
                  ) : (
                    <></>
                  )}

                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        {type === 'IN' ? 'Tiền thu' : 'Tiền chi'}(đ)<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="amount"
                          rules={{
                            required: "Vui lòng nhập thông tin",
                          }}
                          render={({ onChange, value, ref }) => (
                            <NumericFormat
                              disabled={currency !== 'VND'}
                              className="form-control"
                              inputRef={ref}
                              type="text"
                              value={value}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                              onValueChange={(val) =>
                                onChange(val.floatValue)
                              }
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="amount"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Nội dung
                      </label>
                      <div className="form-control-wrap">
                        <input
                          className="form-control"
                          type="text"
                          name="content"
                          ref={register()}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="content"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col size="6">
                    <div className="form-group">
                      <label className="form-label" >
                        Ghi chú
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control"
                          name="note"
                          ref={register()}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="note"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>

                </Row>
              </div>

              <Row className="g-3 ">
                <Col size="6 " className="mt-3">
                  <Button color="primary" type="submit">
                    <span>Lưu</span>
                  </Button>
                  {isEdit ? <Button color="danger" className={`ml-2`} type="button" onClick={() => {
                    setDeleteId(id);
                    toggle("isDelete");
                  }}>
                    <span>Xoá dữ liệu</span>
                  </Button> : <></>}

                </Col>
              </Row>
            </form>
          </FormProvider>
        </div>
      </div>
      <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn xoá không ?{" "}
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onFormCancel()}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={(ev) => {
                  ev.preventDefault();
                  deleteCustomerMoneyFlow(deleteId);
                }}
              >
                Xác nhận
              </Button>

            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default PNAddCustomerMoneyFlow;
